import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import axios from "axios";
import React, { useState } from "react";
import Button from "./Button";
import { useToast } from "./Toast";
const AddKiosk = ({ open, onClose, clinicId }) => {
  const Toast = useToast();
  const [kioskDetails, setKioskDetails] = useState({
    kioskName: "",
    //  kioskCode: '',
    kioskLocation: "",
  });
  const [errors, setErrors] = useState({
    kioskName: "",
    // kioskCode: '',
    kioskLocation: "",
  });
  const handleKioskChange = (e) => {
    const { name, value } = e.target;
    setKioskDetails((prevDetails) => ({ ...prevDetails, [name]: value }));
  };
  const token = localStorage.getItem("token");
  const handleSave = async () => {
    setErrors({
      kioskName: "",
      kioskLocation: "",
    });

    let valid = true;
    const newErrors = {};

    // Validation
    if (!kioskDetails.kioskName) {
      newErrors.kioskName = "Kiosk Name is required";
      valid = false;
    }

    if (!kioskDetails.kioskLocation) {
      newErrors.kioskLocation = "Location is required";
      valid = false;
    }

    if (!valid) {
      setErrors(newErrors);
      return;
    } else {
    
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_HOST_URL}/ops/v1/kiosks/create`,
          {
            kiosk: {
              name: kioskDetails.kioskName,
              location: kioskDetails.kioskLocation,
              // Add other kiosk details as needed
            },
            clinicId: clinicId, // Replace with actual clinicId
          },
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        Toast.success("Kiosk created successfully");
        onClose(); 
        
      } catch (error) {
        console.error(
          "Error creating kiosk:",
          error.response ? error.response.data : error.message
        );
      }
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle sx={{ fontWeight: "bold" }}>Add New Kiosk</DialogTitle>
      <DialogContent>
        <Box>
          <Typography variant="h6" gutterBottom>
            Kiosk Details
          </Typography>

          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Kiosk Name"
                name="kioskName"
                value={kioskDetails.kioskName}
                onChange={handleKioskChange}
                fullWidth
                error={!!errors.kioskName}
                helperText={errors.kioskName}
              />
            </Grid>
            {/* <Grid item xs={12} sm={4}>
              <TextField
                label="Code"
                name="kioskCode"
                value={kioskDetails.kioskCode}
                onChange={handleKioskChange}
                fullWidth
                error={!!errors.kioskCode}
                helperText={errors.kioskCode}
              />
            </Grid> */}
            <Grid item xs={12} sm={6}>
              <TextField
                label="Location"
                name="kioskLocation"
                value={kioskDetails.kioskLocation}
                onChange={handleKioskChange}
                fullWidth
                error={!!errors.kioskLocation}
                helperText={errors.kioskLocation}
              />
            </Grid>
          </Grid>
        </Box>
      </DialogContent>
      <DialogActions
        style={{ display: "flex", justifyContent: "center", gap: "2px" }}
      >
        <Button
          backgroundColor="#CCD3DA"
          color="#000"
          hoverColor="#A9A9A9"
          text="Cancel"
          width="150px"
          onClick={onClose}
        />
        <Button text="Save" width="150px" onClick={handleSave} />
      </DialogActions>
    </Dialog>
  );
};

export default AddKiosk;
